import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

export type FeedbackFormProps = {
  question: string;
};

export type FeedbackFormDisplayedEvent = TrackingEvent<
  "Feedback Form Displayed",
  { form_question: string }
>;

export async function trackFeedbackFormDisplayedEvent({
  question,
}: FeedbackFormProps): TrackingEventResponse {
  return await trackEvent("Feedback Form Displayed", {
    props: { form_question: question },
    withRequestSource: true,
  });
}
